import axios from 'axios'

const GET_REQUEST = 'get'
const POST_REQUEST = 'post'
const dataServerUrl =
    'http://127.0.0.1:5013'
    // 'http://dehumorbc.ust.weihuan.tech'
    // process.env.DATA_SERVER_URL || 'http://127.0.0.1:5013'

function request(url, params, type, callback) {
    let func
    if (type === GET_REQUEST) {
        func = axios.get;
    } else if (type === POST_REQUEST) {
        func = axios.post;
    }

    func(url, params).then((response) => {
            if (response.status === 200) {
                callback(response)
            } else {
                console.error(response)
            }
        })
        .catch((error) => {
            console.error(error)
        })
}

// front-end emit JSON data to backend

function getSTAT(stat_data, callback) {
    const params = stat_data;
    const url = `${dataServerUrl}/statistic`;
    request(url, params, POST_REQUEST, callback);
}

function getSTORY(story_data, callback) {
    const params = story_data;
    const url = `${dataServerUrl}/storyview`;
    request(url, params, POST_REQUEST, callback);
}

function getPROJ(story_data, callback) {
    const params = story_data;
    const url = `${dataServerUrl}/projview`;
    request(url, params, POST_REQUEST, callback);
}

function getDETAIL(detail_data, callback) {
    const params = detail_data;
    const url = `${dataServerUrl}/detailview/videofeature`;
    request(url, params, POST_REQUEST, callback);
}

function humorQuery(humorquery, callback) {
    const params = humorquery;
    const url = `${dataServerUrl}/humorquery`;
    request(url, params, POST_REQUEST, callback);
}

// get keywords data
function getControlPanelKeywordsData(datasetType, callback) {
    const url = `${dataServerUrl}/controlpanel/keywords/${datasetType}`;
    const params = {};
    request(url, params, GET_REQUEST, callback);
}

// get textfeature
function getControlPanelTextfeaturelist(datasetType, callback) {
    const url = `${dataServerUrl}/controlpanel/textfeaturelist/${datasetType}`;
    const params = {};
    request(url, params, GET_REQUEST, callback);
}

// get control panel data
function getControlPanelData(datasetType, callback) {
    const url = `${dataServerUrl}/controlpanel/data/${datasetType}`;
    const params = {};
    request(url, params, GET_REQUEST, callback);
}

// get category
function getControlPanelCategory(datasetType, callback) {
    const url = `${dataServerUrl}/controlpanel/category/${datasetType}`;
    const params = {};
    request(url, params, GET_REQUEST, callback);
}

// get meta
function getMetadata(datasetType, callback) {
    const url = `${dataServerUrl}/controlpanel/metadata/${datasetType}`;
    const params = {};
    request(url, params, GET_REQUEST, callback);
}

// get punchline query
function punchlinequery(humorquery, callback) {
    const params = humorquery;
    const url = `${dataServerUrl}/punchlinequery`;
    request(url, params, POST_REQUEST, callback);
}

// get humordetail data
function getHumorDetail(query, callback) {
    const params = query;
    const url = `${dataServerUrl}/humordetail`;
    request(url, params, POST_REQUEST, callback);
}

function initialization(videoId, callback) {
    const url = `${dataServerUrl}/initialization/${videoId}`
    const params = {}
    request(url, params, GET_REQUEST, callback)
}

function videoInfo(videoId, callback) {
    const url = `${dataServerUrl}/videoInfo/${videoId}`
    const params = {}
    request(url, params, GET_REQUEST, callback)
}

export default {
    dataServerUrl,
    getControlPanelData,
    getControlPanelKeywordsData,
    getSTAT,
    getSTORY,
    getPROJ,
    getDETAIL,
    humorQuery,
    getControlPanelTextfeaturelist,
    getControlPanelCategory,
    initialization,
    videoInfo,
    getMetadata,
    punchlinequery,
    getHumorDetail
}